/**
 * @(#)2019/9/6.
 * 图片组件，展示一组或者一个图片
 * @author 足道
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import { isEqual, isArray, isObject } from "lodash";
import React, { Component } from "react";
import { toArray, get, merge } from "../../../utils";
import Img from "./Img";
import PropTypes from "prop-types";
import { ITextBasePropTypes } from "../IpropType/basePropTypes";
Img.propTypes = {
  ...ITextBasePropTypes,
  list: PropTypes.array,
  onlySee: PropTypes.bool,
};

Img.defaultProps = {
  list: null,
  onlySee: true, //只能看
  styleParam: {
    size: "default", //大小
    type: "default", //类型
  },
};

export default Img;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxText/Img/index.js